import { useEffect, useState } from 'react';

interface FilterItem {
  value: string;
  label: string;
}

/**
 * Accumulates an id -> label map across every `items` list passed in, so the
 * label of an already-seen option survives async search filtering / pagination
 * that later removes it from `items`.
 */
export default function useSelectedFilterLabels(items: FilterItem[]) {
  const [labelsById, setLabelsById] = useState<Record<string, string>>({});

  useEffect(() => {
    if (items.length === 0) return;

    setLabelsById((prev) => {
      let changed = false;
      const next = { ...prev };
      items.forEach(({ value, label }) => {
        if (next[value] !== label) {
          next[value] = label;
          changed = true;
        }
      });
      // Return the previous reference when nothing changed so React can bail
      // out of the re-render (overlapping search/pagination results are common).
      return changed ? next : prev;
    });
  }, [items]);

  return labelsById;
}
